import React, { useEffect, useState } from 'react';

import profileImg from '../assets/images/profile-ic.svg';
import emailImg from '../assets/images/mail-ic.svg';
import phoneImg from '../assets/images/phone-ic.svg';
import supporticonImg from '../assets/images/support-ic.svg';
import maileditImg from '../assets/images/message-ic.svg';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phone: '',
    support_type: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setErrors((prev) => ({ ...prev, [e.target.name]: '' })); // Clear error
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.fullname.trim()) {
      newErrors.fullname = 'Full name is required.';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format.';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required.';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Phone number must be 10 digits.';
    }

    if (!formData.support_type) {
      newErrors.support_type = 'Please select a support type.';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    const isValid = validate();
    if (!isValid) return;

    setIsSubmitting(true);

    try {
      const res = await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus('Message sent successfully!');
        setFormData({
          fullname: '',
          email: '',
          phone: '',
          support_type: '',
          message: '',
        });
      } else {
        setStatus('Failed to send message.');
      }
    } catch (err) {
      console.error('Error:', err);
      setStatus('Error sending message.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setStatus(''), 4000);
    }
  };

  useEffect(() => {
    setFormData({
      fullname: '',
      email: '',
      phone: '',
      support_type: '',
      message: '',
    });
    setStatus('');
    setErrors({});
  }, []);

  return (
    <div
      id="contact"
      className="bg-[#2C4728] py-8 sm:py-16 px-5 sm:px-6 md:px-12 text-white font-serif relative z-10"
    >
      <div className=" rounded-[30px]  lg:p-[50px] p-[20px] text-left border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 relative z-[1] max-w-[1260px] mx-auto bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)]">
        <h2 className=" font-cinzel  lg:text-[40px] text-[30px] font-bold text-white leading-[120%] w-full text-center mb-[20px]">
          Get in touch
        </h2>
        <p className="font-ubuntu  lg:text-[32px] text-[20px] w-full text-center mt-0">
          Want to collaborate, sponsor or learn more?{' '}
        </p>
        <span className="font-ubuntu  lg:text-[24px] text-[16px] w-full text-center block">
          Fill the form and we will get back to you.
        </span>
        <form onSubmit={handleSubmit}>
          <div className="gap-5 flex flex-wrap my-7 lg:my-[60px]	">
            <div className="flex w-full lg:flex-row flex-col	 lg:gap-[50px] gap-[20px]">
              <div className="w-full">
                <div className="relative ">
                  <input
                    type="text"
                    name="fullname"
                    value={formData.fullname}
                    onChange={handleChange}
                    placeholder="Full Name"
                    className="bg-[#2C4728] border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 font-ubuntu  lg:text-[24px] text-[18px] rounded-[22px] lg:h-[85px] h-[70px] w-full px-[50px] bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)] focus:border-[#fff] focus:outline-none placeholder-white"
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <img src={profileImg} alt="Full Name" className=" " />
                  </div>
                </div>
                {errors.fullname && (
                  <p className="font-ubuntu text-[14px] text-[#ff0000]">
                    {errors.fullname}
                  </p>
                )}
              </div>
              <div className="w-full">
                <div className="relative ">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    className="bg-[#2C4728] border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 font-ubuntu  lg:text-[24px] text-[18px] rounded-[22px] lg:h-[85px] h-[70px] w-full px-[50px] bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)] focus:border-[#fff] focus:outline-none placeholder-white"
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <img src={emailImg} alt="Email Address" className=" " />
                  </div>
                </div>
                {errors.email && (
                  <p className="font-ubuntu text-[14px] text-[#ff0000]">
                    {errors.email}
                  </p>
                )}
              </div>
            </div>
            <div className="flex w-full lg:flex-row flex-col	 lg:gap-[50px] gap-[20px]">
              <div className="w-full">
                <div className="relative ">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    maxLength={10}
                    className="bg-[#2C4728] border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 font-ubuntu  lg:text-[24px] text-[18px] rounded-[22px] lg:h-[85px] h-[70px] w-full px-[50px] bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)] focus:border-[#fff] focus:outline-none placeholder-white"
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <img src={phoneImg} alt="Phone Number" className=" " />
                  </div>
                </div>
                {errors.phone && (
                  <p className="font-ubuntu text-[14px] text-[#ff0000]">
                    {errors.phone}
                  </p>
                )}
              </div>

              <div className="w-full">
                <div className="relative ">
                  <div className="relative inline-block text-left w-full">
                    <div className="w-full relative">
                      <select
                        name="support_type"
                        value={formData.support_type}
                        onChange={handleChange}
                        className="bg-[#2C4728] border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 font-ubuntu  lg:text-[24px] text-[18px] rounded-[22px] lg:h-[85px] h-[70px] w-full px-[50px] bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)] focus:border-[#fff] focus:outline-none placeholder-white"
                      >
                        <option>Support Type</option>
                        <option>Donate</option>
                        <option>Sponsor Book Tour</option>
                        <option>Fund Film</option>
                        <option>General Inquiry</option>
                      </select>
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <img
                          src={supporticonImg}
                          alt="Support Type"
                          className=" "
                        />
                      </div>
                    </div>
                    {errors.support_type && (
                      <p className="font-ubuntu text-[14px] text-[#ff0000]">
                        {errors.support_type}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex w-full gap-[50px]">
              <div className="w-full">
                <div className="relative ">
                  <textarea
                    type="text"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    className="p-6 h-[200px] bg-[#2C4728] border-t-2 border-l-2 border-r-[1px] border-b-[1px] border-solid border-[#fff]/30 font-ubuntu  lg:text-[24px] text-[18px] rounded-[22px] h-[200px] w-full px-[50px] bg-[linear-gradient(138.77deg,_rgba(255,255,255,0.22)_5.93%,_rgba(255,255,255,0)_37.62%)] focus:border-[#fff] focus:outline-none resize-none placeholder-white"
                  />
                  <div className="absolute lg:top-[30px] top-[25px] left-0 flex items-center pl-3">
                    <img src={maileditImg} alt="Message" className=" " />
                  </div>
                </div>{' '}
                {errors.message && (
                  <p className="font-ubuntu text-[14px] text-[#ff0000]">
                    {errors.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={`group relative bg-gradient-to-r from-yellow-400 to-yellow-500 
    lg:ps-[30px] lg:pe-[30px] px-[20px] py-[16px] lg:py-[0] 
    flex items-center justify-center sm:text-center sm:justify-center 
    mx-auto lg:leading-[88px] border gap-[10px] border-solid border-white 
    lg:min-w-[550px] min-w-[200px] lg:text-[20px] text-[14px] font-ubuntu 
    font-bold rounded-full text-white overflow-hidden 
    hover:bg-custom-gradient-btn transition-opacity duration-300 
    ${isSubmitting ? 'opacity-60 cursor-not-allowed' : ''}`}
          >
            <span className="transition-all duration-400 ease-ease-custom transform">
              Submit
            </span>

            {isSubmitting && (
              <div className="ml-3 w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            )}
          </button>

          {status && (
            <div
              className={`mt-4 px-4 py-3 font-ubuntu rounded shadow-lg text-white transition-all duration-300 ${
                status.includes('success') ? 'bg-green-500' : 'bg-red-500'
              }`}
            >
              {status}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
